import {idPrefixToEntityName} from '../idHelpers.config';
import {WrongPrefixError} from '../idHelpers.types';

export default function formatWrongPrefixError(error: WrongPrefixError): string {
  const detectedName = idPrefixToEntityName[error.detectedPrefix];
  const expectedName = error.expectedPrefix.map((p) => idPrefixToEntityName[p]).join(' or ');

  return `Received ${detectedName} ID (${error.rawValue}) but expected ${expectedName} ID`;
}
